import * as React from "react";

import "./ml-address-card.scss";

import {UseState}                       from "@Common/react/use-state";
import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {faEllipsis}                     from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";
import {ConfirmDialog}                  from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {AddressModalA}                  from "@Common/ui-components/heavy/mailing-ui/ml-addresses-table/address-modal-a";
import {API_REQUEST_SUCCESS}            from "../edit-mailing-list-modal-mobile/edit-mailing-list-modal-mobile"

export const MlAddressCard = ({address, addresses, entityId}) => cs(
    ["menuExpanded", ({}, next) => UseState({
        initValue: false,
        next,
    })],
    consumeContext("apis"),
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ["addressModal", (_, next) => AddressModalA({next})],        
    ({menuExpanded, confirmDialog, addressModal, apis}) => (
        <div className="m1-address-card-SiO2" >

            <div className="m1-address-card-row header">
                <div className="m1-address-card-name">
                    {address?.name || 'Unnamed'}
                </div>
                {
                    '0' === address.failed
                    ?
                    <div className="m1-address-card-icon success">
                        Good
                    </div>
                    :
                    <div className="m1-address-card-icon failed">
                        Failed
                    </div>        
                }                   
                    <div 
                        className="m1-address-card-icon-ellipsis"
                        onClick={(e) => {
                            e.stopPropagation()
                            menuExpanded.onChange(!menuExpanded.value)
                        }}
                    >
                        <FontAwesomeIcon 
                            icon={faEllipsis}
                            className='icon-ellipsis'
                        />
                        {
                            menuExpanded.value
                            ?
                            <div className="m1-address-card-icon expanded">
                                <div 
                                    className="ml-address-card-edit-address"
                                    onClick={ async (e) => {
                                        e.stopPropagation()                                        
                                        addressModal.show({
                                            actionName: "edit",
                                            onConfirm: (addressEdited, action) => {
                                                (async () => {
                                                    const editSuccessful = await apis.next.mailing.updateMailingAddress(addressEdited, entityId)
                                                    if(API_REQUEST_SUCCESS === editSuccessful.result) {
                                                        addresses.reload()
                                                    }
                                                })()
                                                return action
                                            }, 
                                            initData: address,
                                        })                                        
                                    }}
                                >
                                    Edit
                                </div>
                                <div 
                                    className="ml-address-card-delete-address"
                                    onClick={ async (e) => {
                                        e.stopPropagation()                                        
                                        const confirmed = await confirmDialog.show({ 
                                            message: `${CONFIRM_DELETE} ${address.address}`,
                                            actionName: 'delete',
                                            buttons: {
                                                confirmLabel: "Yes"
                                            }
                                        })
                                        if(confirmed) {                                            
                                            (async () => {                                         
                                                const deleteSuccessful = await apis.next.mailing.deleteMailingAddress(address)
                                                if(API_REQUEST_SUCCESS === deleteSuccessful.result) {
                                                    addresses.reload()
                                                }
                                            })()                                                                                                                                
                                        }
                                    }}
                                >
                                    X
                                </div>           
                            </div>                           
                            :
                            null
                        }
                    </div>
            </div>

            <div className="m1-address-card-row address">
                <div className="m1-address-card-column">
                    <div className="m1-address-card-label">
                        Address
                    </div>
                    <div className="m1-address-card-column-inner">
                        {
                            address?.address
                            &&
                            <div className="m1-address-card-address address1">
                                {address.address}
                            </div>
                        }
                        {
                            address?.address2
                            &&
                            <div className="m1-address-card-address address2">
                                {address.address2}
                            </div>
                        }
                        {
                            (address?.city || address?.state || address?.zip)
                            &&
                            <div className="m1-address-card-address city">
                                {`${commaSeparatedCityState(address)} ${address?.zip || ''}`}
                            </div>
                        }
                    </div>
                </div>
            </div>           
        </div>
    )
);

const commaSeparatedCityState = (address) => {
    const emptyString = ''
    let cityState = emptyString

    if(address.city) {
        cityState += address.city
    }

    if(address.state) {
        cityState += emptyString === cityState ? address.state : `, ${address.state}`
    }

    return cityState
} 

const CONFIRM_DELETE = 'Deleting address:'
